import {
    faDisplay,
    faMagnifyingGlass,
    faMultiply,
    faSolarSystem,
    faPowerOff,
    faTriangleExclamation,
    faMoon,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CdmPhysicalVideoDest } from "userful-chronos-app-common-js/dist/models/cdm/CdmPhysical";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { prettyPrintStationLabel } from "userful-chronos-app-common-js/dist/models/display";
import { useTranslation } from "react-i18next";
import UserfulTooltip from "../../../Widgets/UserfulTooltip";
import React from "react";
import { useMappingSelector } from "userful-chronos-common-store/dist/mapping";

interface IProps {
    item: CdmPhysicalVideoDest;
    itemID: StringID;
    onDelete?: Function;
    handleMouseEnter?: Function;
    handleMouseLeave?: Function;
    inUse?: string;
}

export default function DestinationDisplay(props: IProps) {
    const { t } = useTranslation();

    const offlineStyle = props.item.availability === "NOT_CONNECTED" ? "offline" : "";

    const handleMouseEnter = () => {
        props.handleMouseEnter(true);
    };

    const handleMouseLeave = () => {
        props.handleMouseLeave(false);
    };

    const showingIDs = useMappingSelector((state) => state.uclientsStore.showIDDisplays);
    const isShowingID = showingIDs.findIndex((s) => s.value === props.item.endPoint.id.seatID.value) >= 0;

    const prettyLabel = prettyPrintStationLabel(props.item.endPoint.label);
    const allLetters = /^[A-Za-z]+$/;
    const onboardLabel = t("CommonUI.displayCommon.displayTypeOnboard");
    const displayNumberStyle = (label: string) =>
        ({ "--display-number-length": Math.max(label.length, 1) }) as React.CSSProperties;
    return (
        <>
            <div className="infoBar">
                <div className="infoBarElements">
                    {props.item.endPoint.id.seatID.value === "seat0" ? (
                        <UserfulTooltip placement="top" title={t("Sources&Destinations.Destinations.onboard")}>
                            <div className="greenInfo">
                                <FontAwesomeIcon icon={faSolarSystem} />
                            </div>
                        </UserfulTooltip>
                    ) : (
                        <UserfulTooltip placement="top" title={t("Sources&Destinations.Destinations.display")}>
                            <div className="greenInfo">
                                <FontAwesomeIcon icon={faDisplay} />
                            </div>
                        </UserfulTooltip>
                    )}
                    {props.inUse && (
                        <UserfulTooltip placement="top" title={t("Shared.inUse")}>
                            <div className="yellowInfo">
                                <FontAwesomeIcon icon={faTriangleExclamation} />
                            </div>
                        </UserfulTooltip>
                    )}
                    {props.item.availability === "NOT_CONNECTED" && (
                        <UserfulTooltip title={t("CommonUI.MappingGroups.offlineDestination")}>
                            <div className="powerOffWrapper">
                                <FontAwesomeIcon icon={faPowerOff} />
                            </div>
                        </UserfulTooltip>
                    )}
                    {props.item.availability === "FAILOVER_PASSIVE" && (
                        <UserfulTooltip title={t("CommonUI.MappingGroups.passiveDestination")}>
                            <div className="failoverPassiveWrapper">
                                <FontAwesomeIcon icon={faMoon} />
                            </div>
                        </UserfulTooltip>
                    )}
                    {isShowingID && (
                        <UserfulTooltip placement="top" title={t("CommonUI.showingID")}>
                            <div className="greyInfo">
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </div>
                        </UserfulTooltip>
                    )}
                </div>
                {props.onDelete && (
                    <div className="infoBarActions">
                        <UserfulTooltip title={t("CommonUI.MappingGroups.removeDestination")}>
                            <div className="cardButtons" onClick={() => props.onDelete()}>
                                <FontAwesomeIcon icon={faMultiply} />
                            </div>
                        </UserfulTooltip>
                    </div>
                )}
            </div>
            {props.item.name.length > 14 ? (
                <UserfulTooltip placement="top" title={props.item.name}>
                    <div className="nameBar" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <div className="nameBarText">{props.item.name}</div>
                    </div>
                </UserfulTooltip>
            ) : (
                <div className="nameBar" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <div className="nameBarText">{props.item.name}</div>
                </div>
            )}
            <div className="contentBar">
                <div className="singleDisplayDestination">
                    <img src="./assets/monitor.svg" />
                    {props.item.endPoint.type === "ONBOARD" ? (
                        <div className="display-number onboard" style={displayNumberStyle(onboardLabel)}>
                            {onboardLabel}
                        </div>
                    ) : (
                        <div
                            className={`display-number ${
                                prettyLabel.length > 4 && allLetters.test(prettyLabel) && "onboard"
                            }`}
                            style={displayNumberStyle(prettyLabel)}
                        >
                            {prettyLabel}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
